class StorageRepository {
  refreshToken() {
    // call whatever usecase for refresh token and setThe new one
    // setToken()
  }
}

export { StorageRepository as default };